import { Brand, createBranded } from '@deltasierra/type-utilities';
import { MetricValueType } from '../../../../metrics';

export type NotMOrF = Brand<string, 'NotMOrF'>;
export const NotMOrF = createBranded<NotMOrF>();

export interface FacebookPageAudienceGenderAndAgeMetric extends MetricValueType {
    audienceGender: Record<NotMOrF | 'F' | 'M', Record<string, number>>;
}
